import { Typography } from 'antd';
import classNames from 'classnames';
import React, { FC } from 'react';
import { Comment } from 'api/document/types/document';
import styles from 'components/organisms/document/parts/doc-discussions/discussions-components/discussions-components.module.css';
import { useTranslation } from 'hooks/use-translation';
import { EditComment } from './edit-comment';

const { Paragraph } = Typography;

interface Props {
  comment: Comment;
  projectId: number;
  edit: boolean;
  isActiveDiscussion: boolean;
  isPrivateDiscussion: boolean;
  onEditFormClose: () => void;
  onEdit: (content: string) => void;
  onPrivateClick?: () => void;
  isParent?: boolean;
}

export const Content: FC<Props> = ({
  comment,
  projectId,
  edit,
  isActiveDiscussion,
  onEditFormClose,
  onEdit,
  onPrivateClick = () => {},
  isParent,
}) => {
  const addCommentMsg = useTranslation('add_comment');
  const contentClass = classNames(styles.comment, {
    [styles.comment__private]: comment.private && isParent,
  });
  const ellipsisConfig = !isActiveDiscussion && { rows: 2 };

  return edit ? (
    <EditComment
      initialHtml={comment.content}
      placeholder={addCommentMsg}
      onEditFormClose={onEditFormClose}
      comment={comment}
      projectId={projectId}
      onEdit={onEdit}
      onPrivateClick={onPrivateClick}
    />
  ) : (
    <div className={contentClass}>
      <Paragraph ellipsis={ellipsisConfig}>
        <span
          // TODO: render RTE? @asimkt
          dangerouslySetInnerHTML={{
            // eslint-disable-next-line react/no-danger, @typescript-eslint/naming-convention
            __html: comment.content,
          }}
        />
      </Paragraph>
    </div>
  );
};
